import { Injectable } from '@angular/core';
import { THEME_COUNT, ThemeServiceHelper } from './service.helper';

@Injectable({
  providedIn: 'root'
})
export class ThemeService {
  getAvatarThemeId(itemId: number | string): number {
    return ThemeServiceHelper.getAvatarThemeId(itemId);
  }

  getThemeId(itemId: number | string, themeCount = THEME_COUNT): number {
    return ThemeServiceHelper.getThemeId(itemId, themeCount);
  }

  getThemeCssClassName(themeId: number): string {
    return ThemeServiceHelper.getThemeCssClassName(themeId);
  }
}
